module.exports = __webpack_public_path__ + "static/media/tzu_hung_lu.c1eea713.jpg";